import { createSlice } from "@reduxjs/toolkit";

export const CategoryReducer = createSlice({
    name: "category",
    initialState: {
        selectedProductCategory: '',
        selectedSubCategoryId: null,
        
    },
    reducers: {
        setSelectedProductCategory: (state, action) => {
            state.selectedProductCategory = action.payload;
        },
        setSelectedSubCategoryId: (state, action) => {
            state.selectedSubCategoryId = action.payload;
            // console.log("setSelectedSubCategoryId" , action.payload)
        },
        resetCategoryState: (state) => {
            state.selectedProductCategory = '';
            state.selectedSubCategoryId = null;
        }
    }
});

export const {
    setSelectedProductCategory,
    setSelectedSubCategoryId,
    resetCategoryState
} = CategoryReducer.actions;

export default CategoryReducer.reducer;